module.exports={
	"Form": "UserViewManifest",
	"Scope": "User-View",
	"Descriptors":
	{
		"UserDetails.IDUser":
		{
			"Name": "User ID",
			"Hash": "UserView-IDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "UserIdentity",
				"Group": "UserIdentity"
			}
		},
		"UserDetails.GUIDUser":
		{
			"Name": "GUID",
			"Hash": "UserView-GUIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "UserIdentity",
				"Group": "UserIdentity"
			}
		},
		"UserDetails.NameFirst":
		{
			"Name": "First Name",
			"Hash": "UserView-NameFirst",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 3,
				"Section": "UserIdentity",
				"Group": "UserIdentity"
			}
		},
		"UserDetails.NameLast":
		{
			"Name": "Last Name",
			"Hash": "UserView-NameLast",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 3,
				"Section": "UserIdentity",
				"Group": "UserIdentity"
			}
		},
		"UserDetails.Email":
		{
			"Name": "Email Address",
			"Hash": "UserView-Email",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 6,
				"Section": "UserContact",
				"Group": "UserContact"
			}
		},
		"UserDetails.LoginID":
		{
			"Name": "Login ID",
			"Hash": "UserView-LoginID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 3,
				"Section": "UserContact",
				"Group": "UserContact"
			}
		},
		"UserDetails.Role":
		{
			"Name": "Role",
			"Hash": "UserView-Role",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 3,
				"Section": "UserContact",
				"Group": "UserContact"
			}
		},
		"UserDetails.CreateDate":
		{
			"Name": "Created",
			"Hash": "UserView-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 3,
				"Section": "UserAudit",
				"Group": "UserAudit"
			}
		},
		"UserDetails.CreatingIDUser":
		{
			"Name": "Created By (User ID)",
			"Hash": "UserView-CreatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 3,
				"Section": "UserAudit",
				"Group": "UserAudit"
			}
		},
		"UserDetails.UpdateDate":
		{
			"Name": "Last Updated",
			"Hash": "UserView-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 3,
				"Section": "UserAudit",
				"Group": "UserAudit"
			}
		},
		"UserDetails.UpdatingIDUser":
		{
			"Name": "Updated By (User ID)",
			"Hash": "UserView-UpdatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 3,
				"Section": "UserAudit",
				"Group": "UserAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "UserIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "UserIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Contact & Access",
			"Hash": "UserContact",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Contact & Access",
					"Hash": "UserContact",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Audit Trail",
			"Hash": "UserAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Audit Trail",
					"Hash": "UserAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
